/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
setTimeout(() => {
        const elementHeader = document.querySelector('.header__wrapper');
          if(window.innerWidth < 1399) {
               elementHeader.classList.add('js__show__mobile');
            } else {
               elementHeader.classList.remove('js__show__mobile');
            }
     
    }, 2500);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
